(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Claude-Slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('claude-slideshow')) {
    class ClaudeSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-progress]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.liveRegion = this.querySelector('[data-live-region]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplaySpeed = Number(this.dataset.autoplaySpeed);
        this.interactionPaused = false;
        this.editorPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pointerStart = null;
        this.didSwipe = false;

        this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
        this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.currentIndex - 1, true);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.currentIndex + 1, true);
          }
        });

        this.addEventListener('mouseenter', () => {
          this.interactionPaused = true;
          this.stopAutoplay();
        });

        this.addEventListener('mouseleave', () => {
          this.interactionPaused = false;
          this.startAutoplay();
        });

        this.addEventListener('focusin', () => {
          this.interactionPaused = true;
          this.stopAutoplay();
        });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.interactionPaused = false;
            this.startAutoplay();
          }
        });

        this.viewport?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.pointerStart = { x: event.clientX, y: event.clientY };
        });

        this.viewport?.addEventListener('pointerup', (event) => {
          if (!this.pointerStart || event.pointerType === 'mouse') return;

          const distanceX = event.clientX - this.pointerStart.x;
          const distanceY = event.clientY - this.pointerStart.y;
          this.pointerStart = null;

          if (Math.abs(distanceX) < 50 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

          this.didSwipe = true;
          this.show(distanceX > 0 ? this.currentIndex - 1 : this.currentIndex + 1, true);
          window.setTimeout(() => {
            this.didSwipe = false;
          }, 0);
        });

        this.viewport?.addEventListener('click', (event) => {
          if (!this.didSwipe) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);

        this.onVisibilityChange = () => {
          document.hidden ? this.stopAutoplay() : this.startAutoplay();
        };

        this.onBlockSelect = (event) => {
          const selectedSlide = event.target.closest('[data-slide]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;

          this.editorPaused = true;
          this.show(Number(selectedSlide.dataset.slideIndex), false);
        };

        this.onBlockDeselect = () => {
          this.editorPaused = false;
          this.startAutoplay();
        };

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.updateSlides(this.currentIndex, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      show(index, announce) {
        if (this.slides.length < 2) return;

        this.stopAutoplay();
        const nextIndex = (index + this.slides.length) % this.slides.length;
        const update = () => this.updateSlides(nextIndex, announce);

        if (document.startViewTransition && !this.reducedMotion.matches) {
          try {
            const transition = document.startViewTransition(update);
            transition.finished.finally(() => this.startAutoplay());
            return;
          } catch (error) {
            update();
          }
        } else {
          update();
        }

        this.startAutoplay();
      }

      updateSlides(nextIndex, announce) {
        this.currentIndex = nextIndex;

        this.slides.forEach((slide, index) => {
          const active = index === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;

          slide.querySelectorAll('video').forEach((video) => {
            if (active && !this.reducedMotion.matches) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        if (this.progress && this.progressBar && this.slides.length > 0) {
          const currentSlide = nextIndex + 1;
          const segmentWidth = 100 / this.slides.length;
          const segmentPosition = nextIndex * segmentWidth;
          this.progressBar.style.width = `${segmentWidth}%`;
          this.progressBar.style.left = `${segmentPosition}%`;
          this.progress.setAttribute('aria-valuenow', String(currentSlide));
          this.progress.setAttribute('aria-valuetext', `Slide ${currentSlide} of ${this.slides.length}`);
        }

        if (announce && this.liveRegion) {
          this.liveRegion.textContent = `Slide ${nextIndex + 1} of ${this.slides.length}`;
        }
      }

      startAutoplay() {
        this.stopAutoplay();

        if (
          this.autoplaySpeed <= 0 ||
          this.interactionPaused ||
          this.editorPaused ||
          this.reducedMotion.matches ||
          document.hidden ||
          this.slides.length < 2
        ) {
          return;
        }

        this.autoplayTimer = window.setTimeout(() => {
          this.show(this.currentIndex + 1, false);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;

        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('claude-slideshow', ClaudeSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
